import { combineReducers } from "redux"
import farmers from "./farmers"

const farmerReducer = combineReducers({
  farmers,
})

export default farmerReducer
